import React from 'react';
import { useContext, createContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import { useServerProps } from '../../serverProps';
import QueryDatabase from "../DataContext/QueryDatabase";

const AuthorisationContext = createContext();

const AuthorisationProvider = ({ children }) => {

    const [token, setToken] = useState(JSON.parse(localStorage.getItem("recipeSite")) || "");
    const [user, setUser] = useState(token.userName || null);
    const [userID, setID] = useState(token.userID || null)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const serverProps = useServerProps();

    const loginAction = async (data) => {
        try {
            setLoading(true)
            const res = await QueryDatabase({
                table: "users",
                method: 3,
                data: data,
                serverName: serverProps.DatabaseServer,
                serverPort: serverProps.DatabasePort
            })
            setLoading(false)
            if (res && res !== -1 && !res.error) {
                console.log("res: " + JSON.stringify(res) + "\nres.userName: " + res.userName + "\nres.userID: " + res.userID)
                setUser(res.userName);
                setID(res.userID);
                setToken(res);
                localStorage.setItem("recipeSite", JSON.stringify(res))
                navigate("/");
                return
            }
            throw new Error("Invalid login credentials");
        } catch (err) {
            console.error(err);
            return err;
        }
    }

    const setupAction = async (data) => {
        try {
            setLoading(true)
            const res = await QueryDatabase({
                table:"users",
                method: 4,
                data: data,
                serverName: serverProps.DatabaseServer,
                serverPort: serverProps.DatabasePort
            })
            setLoading(false)
                        
            if (res.error) {
                return res;
            }

            if (res && res !== -1 && !res.error) {
                setUser(res.userName);
                setToken(JSON.stringify(res));
                localStorage.setItem("recipeSite", JSON.stringify(res))
                navigate("/");
                return
            }
            throw new Error("Invalid login credentials");
        } catch (err) {
            console.error(err);
            return err;
        }
    }

    const logoutAction = () => {
        setUser(null);
        setToken("");
        localStorage.removeItem("recipeSite");
        navigate("/login");
    }

    return <AuthorisationContext.Provider value={{token, user, userID, loginAction, logoutAction, setupAction, loadingLogin:loading} }>{children}</AuthorisationContext.Provider>
}

export default AuthorisationProvider;

export const useAuthorisation = () => {
    return useContext(AuthorisationContext);
}